/**
 * Profile-picture URL helpers.
 *
 * Images must come from Blocks File Storage. Legacy base44 links (base44.app /
 * media.base44.com) are treated as unavailable so the UI falls back to initials.
 */

/** True for legacy base44-hosted URLs. */
export function isBase44Url(url) {
  return typeof url === 'string' && /base44/i.test(url);
}

/**
 * Return a displayable photo URL, or null to fall back to initials.
 * Filters out legacy base44 links (only Blocks-storage / other URLs pass through).
 */
export function displayPhotoUrl(url) {
  return url && !isBase44Url(url) ? url : null;
}
